import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ClientPoint, ClientPointRequest } from '../../api/gen_api_client/routing_pb';
import { ClientPointServiceClient } from '../../api/gen_api_client/RoutingServiceClientPb';
import { GeologicServiceClient } from '../../api/gen_api_client/GeologicServiceClientPb';
import { GeocodeRequest } from '../../api/gen_api_client/geologic_pb';
import { City, Company, CediPoint, GmapOptions, Country, NewPointCedi } from '../../../shared/models/interface/parametrizacion.interface';
import { RoutingService } from '../../providers/routing.service';
import { GrpcFactoryService } from '../../sharedServices/grpc-factory.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-cedi-point',
  templateUrl: './create-cedi-point.component.html',
  styleUrls: ['./create-cedi-point.component.sass'],
})
export class CreateCediPointComponent implements OnInit, OnChanges {
  @Input() cities: City[] = [];
  @Input() company: Company;
  @Input() country: Country;
  @Input() cediToEdit: NewPointCedi;
  @Input() filtercities: City[] = [];
  @Input() labelbutton: string;
  @Output() filteredcities = new EventEmitter<string>();
  @Output() closecedimodal = new EventEmitter();
  @Output() showtoast = new EventEmitter();

  public geologicClient: GeologicServiceClient;
  public geologicRequest: GeocodeRequest;
  public clientServicePoint: ClientPointServiceClient;
  public clientPoint: ClientPoint;
  public clientPointRequest = new ClientPointRequest();
  public newCediPoint: CediPoint;
  public options: GmapOptions;
  public overlays: any[];
  public cediType: string;
  public formError = true;
  public addressError = false;

  constructor(private routingSvc: RoutingService, private grpcFactoryService: GrpcFactoryService) {
    /** */
  }

  ngOnInit() {
    this.geologicClient = this.grpcFactoryService.create(GeologicServiceClient, environment.hostnameMassive, 'GeologicServiceClient');
    this.geologicRequest = new GeocodeRequest();
    this.clientServicePoint = this.grpcFactoryService.create(
      ClientPointServiceClient,
      environment.hostnameMassive,
      'ClientPointServiceClient'
    );
    this.clientPoint = new ClientPoint();
    this.clientPointRequest = new ClientPointRequest();

    this.newCediPoint = {
      city: {
        id: 0,
        name: '',
        geoName: '',
      },
      coordinates: {
        address: '',
        lat: 0,
        lng: 0,
      },
      name: '',
    };

    this.options = {
      center: { lat: 4.6097102, lng: -74.081749 },
      zoom: 12,
      mapTypeId: 'roadmap',
    };
  }

  ngOnChanges(changes: SimpleChanges) {
// eslint-disable-next-line no-prototype-builtins
    if (changes !== null && changes?.hasOwnProperty('cediToEdit') && changes?.cediToEdit?.currentValue !== undefined) {
      this.newCediPoint.id = changes?.cediToEdit?.currentValue?.id;
      this.newCediPoint.city = this.cities.find(res => res?.id === changes?.cediToEdit?.currentValue?.idCity);
      this.newCediPoint.coordinates.address = changes.cediToEdit.currentValue.address;
      this.newCediPoint.coordinates.lat = changes.cediToEdit.currentValue.lat;
      this.newCediPoint.coordinates.lng = changes.cediToEdit.currentValue.lng;
      this.newCediPoint.name = changes.cediToEdit.currentValue.name;
      this.cediType = changes.cediToEdit.currentValue.istDistributionCenter === true ? 'cedi' : 'tienda';
      this.setMarkertPoint(+changes.cediToEdit.currentValue.lat, +changes.cediToEdit.currentValue.lng);
    }
  }

  filteredCitiesChild($event) {
    this.filteredcities.emit($event);
  }

  handleAddresMap(event) {
    const address = event.target.value;
    this.routingSvc
      .getLatLngFromAdress(address, this.country.geoName, this.newCediPoint.city.geoName)
      .then(res => {
        const coordinates = res;

        this.newCediPoint.coordinates = {
          address,
          lat: coordinates.lat,
          lng: coordinates.lng,
        };
        this.addressError = false;
        this.setMarkertPoint(+coordinates.lat, +coordinates.lng);
      })
      .catch(err => {
        if (err) {
          this.addressError = true;
        }
      });
  }

  setMarkertPoint(lat: number, lng: number): void {
    this.overlays = [
      new google.maps.Marker({
        position: { lat, lng },
        title: 'Konyaalti',
      }),
    ];

    const bounds = new google.maps.LatLngBounds();
    this.overlays.forEach(marker => {
      bounds.extend(marker.getPosition());
    });
  }

  validateCediPointForm(cediPoint) {
    if (cediPoint.name.length === 0 || cediPoint.coordinates.address.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  handleCloseCreateCediPoint() {
    this.closecedimodal.emit({ newCediPoint: this.newCediPoint, typeCedi: this.cediType });
    this.newCediPoint = {
      city: {
        id: 0,
        name: '',
        geoName: '',
      },
      coordinates: {
        address: '',
        lat: 0,
        lng: 0,
      },
      name: '',
    };
    this.cediType = '';
  }

  showSuccess() {
    this.showtoast.emit();
  }

  createNewPointCedi(): void {
    const typeCedi = this.cediType === 'cedi' ? true : false;
    this.validateCediPointForm(this.newCediPoint);
    this.routingSvc
      .createNewPointCedi(this.newCediPoint, typeCedi, this.company.id)
      .then(res => {
        if (res) {
          this.handleCloseCreateCediPoint();
          this.showSuccess();
        }
      })
      .catch(console.log);
  }
}
